export const canExecute = (event: KeyboardEvent) => {
  const nodeName = (event.target as HTMLElement).nodeName;

  if (nodeName === "TEXTAREA" || nodeName === "INPUT") {
    return false;
  }

  if (!event.metaKey && !event.ctrlKey) {
    return false;
  }

  event.preventDefault();

  return true;
};
